(function () {
  var sel = {
    drawer: '#CartDrawer',
    toggle: '[data-cart-drawer-toggle]',
    close: '[data-cart-drawer-close]',
    items: '[data-cart-drawer-items]',
    empty: '[data-cart-drawer-empty]',
    footer: '[data-cart-drawer-footer]',
    subtotal: '[data-cart-drawer-subtotal]',
    freeShippingWrap: '.cart-drawer__free-shipping',
    freeShippingMessage: '[data-free-shipping-message]',
    freeShippingFill: '[data-free-shipping-fill]',
    cartCount: '[data-cart-count]'
  };

  var drawer = document.querySelector(sel.drawer);
  if (!drawer) return;

  function qs(selector, ctx) { return (ctx || document).querySelector(selector); }

  function moneyFormat(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
  }

  function renderItem(item) {
    var imageUrl = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_150x150$1') : '';
    var image = imageUrl ? '<img src="' + imageUrl + '" alt="" loading="lazy">' : '';
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>' : '';
    return '' +
      '<div class="cart-drawer__item" data-cart-drawer-line="' + item.key + '">' +
        '<div class="cart-drawer__item-image">' + image + '</div>' +
        '<div class="cart-drawer__item-info">' +
          '<div class="cart-drawer__item-title">' + item.product_title + '</div>' +
          variantTitle +
          '<div class="cart-drawer__item-price">' + moneyFormat(item.final_price) + '</div>' +
          '<div class="cart-drawer__item-qty">' +
            '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-decrease aria-label="Decrease quantity">-</button>' +
            '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
            '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-increase aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-remove aria-label="Remove item">&times;</button>' +
      '</div>';
  }

  function updateFreeShippingBar(cart) {
    var wrap = qs(sel.freeShippingWrap, drawer);
    if (!wrap) return;
    var threshold = parseInt(wrap.getAttribute('data-free-shipping-threshold'), 10) || 0;
    if (threshold <= 0) {
      wrap.style.display = 'none';
      return;
    }
    var messageEl = qs(sel.freeShippingMessage, drawer);
    var fillEl = qs(sel.freeShippingFill, drawer);
    var remaining = threshold - cart.total_price;
    var percent = Math.min(100, Math.max(0, (cart.total_price / threshold) * 100));
    fillEl.style.width = percent + '%';

    if (remaining <= 0) {
      messageEl.innerHTML = 'You\u2019ve unlocked <strong>free shipping!</strong>';
      wrap.classList.add('cart-drawer__free-shipping--unlocked');
    } else {
      wrap.classList.remove('cart-drawer__free-shipping--unlocked');
      messageEl.innerHTML = 'Add <strong>' + moneyFormat(remaining) + '</strong> more for free shipping';
    }
  }

  function renderCart(cart) {
    var itemsEl = qs(sel.items, drawer);
    var emptyEl = qs(sel.empty, drawer);
    var footerEl = qs(sel.footer, drawer);
    var subtotalEl = qs(sel.subtotal, drawer);
    var cartCountEls = document.querySelectorAll(sel.cartCount);

    cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.style.display = 'none';
    } else {
      emptyEl.hidden = true;
      footerEl.style.display = '';
      itemsEl.innerHTML = cart.items.map(renderItem).join('');
      subtotalEl.textContent = moneyFormat(cart.total_price);
    }

    updateFreeShippingBar(cart);
    return cart;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetchCart().then(renderCart);
  }

  function changeLineQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (evt) {
    var toggle = evt.target.closest(sel.toggle);
    if (toggle) {
      evt.preventDefault();
      refreshCart().then(openDrawer);
      return;
    }

    if (evt.target.closest(sel.close)) {
      evt.preventDefault();
      closeDrawer();
      return;
    }

    var removeBtn = evt.target.closest('[data-cart-remove]');
    if (removeBtn) {
      evt.preventDefault();
      var lineRemove = removeBtn.closest('[data-cart-drawer-line]');
      changeLineQuantity(lineRemove.getAttribute('data-cart-drawer-line'), 0);
      return;
    }

    var decBtn = evt.target.closest('[data-cart-qty-decrease]');
    if (decBtn) {
      var lineDec = decBtn.closest('[data-cart-drawer-line]');
      var currentDec = parseInt(qs('.cart-drawer__qty-value', lineDec).textContent, 10);
      changeLineQuantity(lineDec.getAttribute('data-cart-drawer-line'), Math.max(0, currentDec - 1));
      return;
    }

    var incBtn = evt.target.closest('[data-cart-qty-increase]');
    if (incBtn) {
      var lineInc = incBtn.closest('[data-cart-drawer-line]');
      var currentInc = parseInt(qs('.cart-drawer__qty-value', lineInc).textContent, 10);
      changeLineQuantity(lineInc.getAttribute('data-cart-drawer-line'), currentInc + 1);
      return;
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') closeDrawer();
  });

  window.CartDrawer = {
    open: function () { refreshCart().then(openDrawer); },
    close: closeDrawer,
    refresh: refreshCart
  };

  // Open the drawer automatically whenever the theme's existing AJAX
  // add-to-cart request (jQuery, in theme.js) completes successfully.
  if (window.jQuery) {
    jQuery(document).ajaxComplete(function (evt, xhr, settings) {
      if (settings && settings.url && settings.url.indexOf('/cart/add.js') !== -1 && xhr.status === 200) {
        window.CartDrawer.open();
      }
    });
  }

  // Keep the cart count / free-shipping progress fresh on load.
  refreshCart();
})();
